<template>
  <v-carousel
    v-model="workShopSlide"
    style="height:100%"
    :dark="$vuetify.theme.dark"
    :light="!$vuetify.theme.dark"
    :hide-delimiters="$vuetify.breakpoint.xs"
  >
    <!-- 1 -->
    <v-carousel-item class="slide-format">
      <Audio
        :file="getAudioFile(1)"
        :slide-number="workShopSlide"
        :update-file="getAudioFile"
      />
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%; ">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="font-size: 1.5em; width: 70%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <v-img src="../assets/RMS2050_logo_color.png" width="500" />
                <h1>
                  {{ $t("message.slideOneTitle") }} <br />
                  {{ $t("message.slideOneDateRange") }}
                </h1>
                <br /><br />
                <p>
                  {{ $t("message.slideOneSubTitle") }}
                  <br />
                  {{ $t("message.slideOneEnableAudio") }}
                </p>
                <p
                  style="font-size: small"
                  v-html="$t(`message.slideOneBrowserSupport`)"
                ></p>
              </div>
              <v-img
                src="../../public/static/Text Background 2.png"
                width="fit-content"
              />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <!-- 2 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content text-left">
                <h1 class="text-center">
                  {{ $t("message.slideTwoTitle") }}
                </h1>
                <br />
                <p>
                  <b>{{ $t("message.slideOneDateRange") }}</b>
                  {{ $t("message.slideTwoWorkshopAccess") }}
                  <br />
                  <b>{{ $t("message.slideTwoWorkshopEndDate") }}</b>
                  {{ $t("message.slideTwoWorkshopEndDateComment") }}
                  <br />
                </p>
                <p>
                  {{ $t("message.slideTwoWorkshopAlternate") }}
                </p>
                <div class="text-center" style="margin-bottom: 5%;">
                  <v-btn color="#B39DDB" @click="toggleSurvey = true">{{
                    $t("message.survey")
                  }}</v-btn>
                </div>
                <iframe
                  style="width: 100%; height: 70vh;"
                  src="https://www.youtube.com/embed/O2OulmAvAio?autoplay=0&rel=0"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                >
                </iframe>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
      <v-dialog v-model="toggleSurvey" :width="modalWidth">
        <div class="text-right" style="background: antiquewhite;">
          <v-btn class="text-right" @click="toggleSurvey = false">X</v-btn>
        </div>
        <v-card style="padding: 2.5%">
          <h1 style="text-transform: capitalize">
            {{ $t("message.survey").toLowerCase() }}
          </h1>
          <br />
          <v-row>
            <v-col>
              <v-btn color="#015594">
                <a
                  :href="surveyPDF"
                  :download="$t('message.survey')"
                  style="text-decoration: none"
                  class="white--text"
                >
                  {{ $t("message.surveyDownloadMessage") }}
                </a>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="#015594">
                <router-link
                  to="/survey"
                  style="text-decoration: none"
                  class="white--text"
                >
                  {{ $t("message.standAloneSurvey") }}
                </router-link>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-carousel-item>

    <v-carousel-item class="slide-format">
      <Audio
        :file="getAudioFile(2)"
        :slide-number="workShopSlide"
        :update-file="getAudioFile"
      />
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 50%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content text-left">
                <v-row :style="$vuetify.breakpoint.xs ? `padding: 5%` : ``">
                  <h1 class="text-center">
                    {{ $t("message.slideThreeTitle") }}
                  </h1>
                  <p>
                    {{ $t("message.slideThreeDetails") }}
                  </p>
                </v-row>
                <v-row>
                  <v-col cols="6" class="text-left">
                    <v-btn
                      class="white--text"
                      color="#015594"
                      @click="goToSlide(3)"
                    >
                      {{ $t("message.moreInfo") }}
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn
                      class="white--text"
                      color="#015594"
                      @click="goToSlide(4)"
                    >
                      {{ $t("message.Workshop") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <v-carousel-item class="slide-format">
      <BackgroundInformation />
    </v-carousel-item>

    <!-- 7 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card style="max-width: 60%;" class="slide-card">
              <v-img
                src="../../public/static/Text Background 1.png"
                width="fit-content"
              />
              <div class="slide-content">
                <!-- <VuetifyAudio :file="audioSetup" /> -->
                <WorkshopFormat
                  :file="getAudioFile(4)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <!-- 9 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <TellUsAboutYou
                  :file="getAudioFile(5)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
                <v-col align="center">
                  <v-btn
                    class="white--text"
                    color="#015594"
                    @click="goToNextSlide"
                  >
                    {{ $t("message.continue") }}
                  </v-btn>
                </v-col>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <!-- 10 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <LiveWorkPlayMap
                  :file="getAudioFile(6)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
                <v-col align="center">
                  <v-btn
                    class="white--text"
                    color="#015594"
                    @click="goToNextSlide"
                  >
                    {{ $t("message.continue") }}
                  </v-btn>
                </v-col>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <TransportationNeedsExercise2
                  :file="getAudioFile(7)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
                <v-col align="center">
                  <v-btn
                    class="white--text"
                    color="#015594"
                    @click="goToNextSlide"
                  >
                    {{ $t("message.continue") }}
                  </v-btn>
                </v-col>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <!-- 11 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <ConcerningLocationsMap
                  :file="getAudioFile(8)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
                <v-checkbox
                  v-model="transportationComments"
                  :label="$t(`message.slideNineExtraCommentsCheckText`)"
                ></v-checkbox>
                <TransportationCommentFields v-if="transportationComments" />
                <v-col align="center">
                  <v-btn
                    class="white--text"
                    color="#015594"
                    @click="goToNextSlide"
                  >
                    {{ $t("message.continue") }}
                  </v-btn>
                </v-col>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <SidePanelScriptText v-if="!$vuetify.breakpoint.xs" />
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <!-- 12 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card
              class="slide-card"
              style="min-width: 375px; max-width: 60%;"
            >
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <TransportationPriorities
                  :file="getAudioFile(9)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextSlide"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <!-- 13 -->
    <v-carousel-item class="slide-format">
      <Audio
        :file="getAudioFile(10)"
        :slide-number="workShopSlide"
        :update-file="getAudioFile"
      />
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="min-width: 50%; max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <h1>{{ $t("message.slideElevenTitle") }}</h1>
                <br /><br />
                <p v-html="$t(`message.slideElevenDetails`)"></p>
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextSlide"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <!-- 14 -->
    <v-carousel-item class="slide-format">
      <PopulationGrowth
        :file="getAudioFile(11)"
        :slide-number="workShopSlide"
        :nextSlide="goToNextSlide"
        :update-file="getAudioFile"
      />
    </v-carousel-item>
    <!-- 15 -->
    <v-carousel-item class="slide-format">
      <EmploymentGrowth
        :file="getAudioFile(12)"
        :slide-number="workShopSlide"
        :nextSlide="goToNextSlide"
        :update-file="getAudioFile"
      />
    </v-carousel-item>
    <!-- 16 -->
    <v-carousel-item class="slide-format">
      <FutureCongestion
        :file="getAudioFile(13)"
        :slide-number="workShopSlide"
        :nextSlide="goToNextSlide"
        :update-file="getAudioFile"
      />
    </v-carousel-item>
    <!-- 17 -->
    <v-carousel-item class="slide-format">
      <ExistingPlannedTransit
        :file="getAudioFile(14)"
        :slide-number="workShopSlide"
        :nextSlide="goToNextSlide"
        :update-file="getAudioFile"
      />
    </v-carousel-item>
    <!-- 18 -->
    <v-carousel-item class="slide-format">
      <ExistingPlannedFacility
        :file="getAudioFile(15)"
        :slide-number="workShopSlide"
        :nextSlide="goToNextSlide"
        :update-file="getAudioFile"
      />
    </v-carousel-item>
    <!-- 19 -->
    <v-carousel-item class="slide-format">
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content">
                <Exercise5Map
                  :file="getAudioFile(16)"
                  :slide-number="workShopSlide"
                  :update-file="getAudioFile"
                />
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextSlide"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <v-carousel-item>
      <RegionNeeds
        :file="getAudioFile(17)"
        :slide-number="workShopSlide"
        :nextSlide="goToNextSlide"
        :update-file="getAudioFile"
      />
    </v-carousel-item>

    <v-carousel-item class="slide-format">
      <Audio
        :file="getAudioFile(18)"
        :slide-number="workShopSlide"
        :update-file="getAudioFile"
      />
      <v-sheet class="wall-with-floor-background" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-col align="center" justify="center" style="padding-bottom: 0%;">
            <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
            <v-card class="slide-card" style="max-width: 60%;">
              <v-img src="../../public/static/Text Background 1.png" />
              <div class="slide-content" style="display: block;">
                <h1>
                  {{ $t(`message.slideTwentyTitle`) }}
                </h1>
                <br />
                <p>
                  {{ $t(`message.slideTwentyCompleteWorkshopInstructions`) }}
                </p>
                <CompleteWorkshopButton />
                <v-divider></v-divider><br />
                <p>
                  {{ $t(`message.slideTwentyHowWasExperienceInfo`) }}
                </p>
                <div class="pa-md-4 mx-lg-auto">
                  <v-btn @click.stop="showExperienceDialog = true">{{
                    $t(`message.slideTwentyHowWasExperienceBtn`)
                  }}</v-btn>
                </div>
                <br />
                <v-divider></v-divider><br />
                <CommentForm :nextSlide="goToNextSlide" />
                <!-- <v-col align="center">
                <v-btn
                  class="white--text"
                  color="#015594"
                  @click="goToNextSlide"
                >
                  {{ $t("message.continue") }}
                </v-btn>
              </v-col> -->
              </div>
              <v-img src="../../public/static/Text Background 2.png" />
            </v-card>
            <v-img
              src="../../public/static/Easel Bottom.png"
              :width="easelBottom"
              eager
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
    <v-dialog v-model="showExperienceDialog" width="500">
      <HowWasYourExperience
        :toggleDialog="toggleExperienceDialog"
        :dialogBoolean="showExperienceDialog"
      />
    </v-dialog>
  </v-carousel>
</template>

<script>
import LiveWorkPlayMap from "@/components/LiveWorkPlayMap.vue";
import ConcerningLocationsMap from "@/components/ConcerningLocationsMap.vue";
import TransportationCommentFields from "@/components/TransportationCommentFields.vue";
import TransportationPriorities from "@/components/TransportationPriorities.vue";
import CommentForm from "@/components/CommentForm.vue";
import SidePanelScriptText from "@/components/SidePanelScriptText.vue";
import HowWasYourExperience from "@/components/HowWasYourExperience.vue";
import Exercise5Map from "@/components/Exercise5Map.vue";
import PopulationGrowth from "@/components/Exercise 4/PopulationGrowth.vue";
import EmploymentGrowth from "@/components/Exercise 4/EmploymentGrowth.vue";
import FutureCongestion from "@/components/Exercise 4/FutureCongestion.vue";
import ExistingPlannedTransit from "@/components/Exercise 4/ExistingPlannedTransit.vue";
import ExistingPlannedFacility from "@/components/Exercise 4/ExistingPlannedFacility.vue";
import TellUsAboutYou from "@/components/TellUsAboutYou.vue";
import TransportationNeedsExercise2 from "@/components/TransportationNeedsExercise2.vue";
import WorkshopFormat from "@/components/WorkshopFormat.vue";
import BackgroundInformation from "@/components/BackgroundInformation.vue";
import RegionNeeds from "@/components/RegionNeeds.vue";
import CompleteWorkshopButton from "@/components/CompleteWorkshopButton.vue";
import Audio from "@/components/Audio.vue";

export default {
  name: "Workshop",
  components: {
    LiveWorkPlayMap,
    ConcerningLocationsMap,
    TransportationCommentFields,
    TransportationPriorities,
    CommentForm,
    SidePanelScriptText,
    HowWasYourExperience,
    Exercise5Map,
    PopulationGrowth,
    EmploymentGrowth,
    FutureCongestion,
    ExistingPlannedTransit,
    ExistingPlannedFacility,
    TellUsAboutYou,
    TransportationNeedsExercise2,
    WorkshopFormat,
    BackgroundInformation,
    CompleteWorkshopButton,
    Audio,
    RegionNeeds
  },
  data: () => ({
    workShopSlide: 0,
    showExperienceDialog: false,
    transportationComments: false,
    toggleSurvey: false
  }),
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "40%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      }
      return "33%";
    },
    surveyPDF() {
      if (this.$i18n.locale === "es") {
        return require("../../public/static/El Paso Survey Spanish.pdf");
      }
      return require("../../public/static/El Paso Survey English.pdf");
    },
    modalWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "40%";
    }
  },
  methods: {
    goToNextSlide() {
      this.workShopSlide++;
    },
    toggleExperienceDialog() {
      this.showExperienceDialog = !this.showExperienceDialog;
    },
    goToSlide(slide) {
      this.workShopSlide = slide;
    },
    getAudioFile(slide) {
      return slide
        ? require(`../../public/static/audio/${this.$i18n.locale}/Slide${slide}.mp3`)
        : "";
    }
  }
};
</script>

<style>
.v-carousel__item {
  height: 100% !important;
  overflow-y: auto;
  background: url("../../public/static/Wall-with-Floor.png") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: bottom !important;
}
.v-carousel__item p,
h1 {
  font-size: 1.5em;
  color: #000000 !important;
}
.wall-with-floor-background {
  background-color: rgba(0, 0, 0, 0) !important;
}
.slide-content {
  padding: 2.5%;
  display: inline-block;
}
.theme--light {
  color: black !important;
}
.gray-background {
  background-color: gray !important;
}
.slide-format {
  height: 100% !important;
}
@media (min-width: 350px) and (max-width: 1023px) {
  .slide-content {
    max-width: 100% !important;
    width: 100% !important;
    font-size: 1em !important;
  }
  .slide-card {
    max-width: 100% !important;
    width: 100% !important;
    font-size: 1em !important;
  }
}
.v-window__next,
.v-window__prev {
  position: fixed !important;
}
</style>
